import { supabase } from '@/lib/supabase';

export const CALL_CENTER_START_CALL_FN = 'call-center-start-call';

export type CallCenterStartCallApiResult = {
  success: boolean;
  call_id?: string;
  message?: string;
  error?: string;
};

export type InvokeCallCenterStartCallOutcome =
  | { ok: true; call_id?: string; message?: string }
  | { ok: false; title: string; detail: string; invokeError?: boolean };

/**
 * Invoca `call-center-start-call` con sesión y, si aplica, `use_webrtc` + `webrtc_username`.
 */
export async function invokeCallCenterStartCall(options: {
  body: Record<string, unknown>;
  useWebrtc: boolean;
  webrtcUsername: string | null;
}): Promise<InvokeCallCenterStartCallOutcome> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session?.access_token) {
    return {
      ok: false,
      title: 'Sesión expirada',
      detail: 'Vuelve a iniciar sesión para poder iniciar llamadas.',
    };
  }

  const body: Record<string, unknown> = { ...options.body };
  if (options.useWebrtc) {
    body.use_webrtc = true;
    if (options.webrtcUsername) body.webrtc_username = options.webrtcUsername;
  }

  const { data, error } = await supabase.functions.invoke(CALL_CENTER_START_CALL_FN, {
    body,
    headers: { Authorization: `Bearer ${session.access_token}` },
  });

  const res = (data ?? {}) as CallCenterStartCallApiResult;
  if (error) {
    return {
      ok: false,
      title: res.error ?? 'Error',
      detail: res.message ?? error.message ?? 'No se pudo iniciar la llamada.',
      invokeError: true,
    };
  }
  if (!res.success) {
    return {
      ok: false,
      title: res.error ?? 'Error',
      detail: res.message ?? 'Revisa la configuración de Llamadas.',
    };
  }
  return { ok: true, call_id: res.call_id, message: res.message };
}
